module.exports = __webpack_public_path__ + "static/media/birthday-cake.4c413c6e.svg";